<template>
  <div class="login-page container">
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    
    <div class="columns is-centered">
      <div class="column card-container is-half">
        <h1 class="title">Login</h1>
        <p class="has-text-danger" v-if="$route.query.redirect">
          You need to login first.
        </p>
        <form class="login-form" @submit.prevent="login">
          <b-field label="Username">
                <b-input type="email" placeholder="email" v-model="username"></b-input>
          </b-field> 
          <b-field label="Password">
                <b-input type="password" placeholder="Password" v-model="password"></b-input>
          </b-field>
          <div class="field is-grouped">
            <div class="control">
              <button class="button is-primary is-medium">Login</button>
            </div>
            <div class="control">
              <router-link class="button is-text is-medium" :to="{name: 'resetPassword'}">Reset Password</router-link>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import loginAPI from '@/api/LoginAPI.js'
import store from '../store.js'
import { mapMutations, mapState } from 'vuex'

export default {
    name: 'Login',
    props: ['usernameProp'],
    data () {
        return {
            username: null,
            password: null,
            hash: null,
            errorMsg: null,
            isLoading: false,
            isFullPage: true,
            notificationDuration: 4000
        }
    },

    computed:{
    ...mapState([
      'userInfo',
      ])
    },

    created() {
        if( this.usernameProp ){
            this.username = this.usernameProp;
        }
        //Allow email and hash to be passed via query params.
        var hash = this.$route.query.hash;
        var email = this.$route.query.email;
        if( hash !== undefined){
            this.hash = hash;
            this.password = hash;
            this.username = email;
        }

        if (this.userInfo.loggedIn) {
          this.$router.replace({ name: 'userInfo', params: {recID: this.userInfo.recID}})
        }

    },
    
    methods: {
        ...mapMutations([
          'setCampaigns', 
          'setEmails',
          'setCampaignsAndEmails',
          'setSelectedCampaign',
          'setExistingPassword'
        ]),
        login: async function(){
            this.isLoading = true
            // Clear stores
            store.commit('setCampaigns', [])
            store.commit('setEmails', [])
            store.commit('setCampaignsAndEmails', [])
            store.commit('setSelectedCampaign', {})
            loginAPI.login(this.username, this.password, this.hash, response => {
                if (response.authenticated != true) {
                    self.errorMsg = response.errorMsg;
                    self.error = true;
                    store.commit('setUserData', {});
                    this.$snotify.error(  self.errorMsg, "Error",
                        {
                            showProgressBar: false,
                            position: 'rightBottom',
                            icon: false,
                            timeout: this.notificationDuration,
                            closeOnClick: true,
                            bodyMaxLength: 1000
                        }
                    )
                    this.isLoading = false
                } 
                else {
                    store.commit('setUserData', response.user);
                    console.log(response.user)
                    if( response.user.isPasswordChangeNeeded ){
                        // this.isLoading = false
                        store.commit('setExistingPassword', this.password)
                        this.$router.push({ name: 'changePassword', params: { userID: response.user.userID, recID: response.user.recID, fromLogin: true}})
                    }
                    else if(this.$route.query.redirect){
                        // this.isLoading = false
                        this.$router.replace( this.$route.query.redirect)
                    }
                    else{
                        // this.isLoading = false
                        this.$router.replace({ name: 'userInfo', params: {recID: response.user.recID}})
                    }
                }
            })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .has-text-danger {
        padding-bottom: 20px;
    }
    .center {
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
    .card-container {
    padding: 2rem;
    margin: 20px 20px 20px 20px;
  } 
  .login-page{
      margin-top:120px;
      margin-bottom:100px;
  }
  /*.field-container {*/
  /*  background-color: #FFFFFF;*/
  /*  border: solid 1px #cccccc;*/
  /*  border-radius: 5px;*/
  /*  padding: 2rem;*/
  /*  margin: 0px 20px 20px 20px;*/
  /*}  */
</style>
